<template>
  <div ref="colorpicker" class="input-group color-picker">
    <span
      v-if="posicion === 'izquierda'"
      :class="clasesBotonColor"
      @click="togglePicker()"
    >
      <span
        class="current-color"
        :style="'background-color: ' + colorValue"
      >
      </span>
    </span>
    <input
      v-show="mostrarInput"
      v-model="colorValue"
      type="text"
      :name="name"
      class="form-control"
      @focus="showPicker()"
      @input="updateFromInput"
    />
    <span
      v-if="posicion !== 'izquierda'"
      :class="clasesBotonColor"
      @click="togglePicker()"
    >
      <span
        class="current-color"
        :style="'background-color: ' + colorValue"
      >
      </span>
    </span>
    <sketch-picker
      v-if="displayPicker"
      :model-value="colors"
      :class="{izquierda: posicion === 'izquierda'}"
      :disable-alpha="disableAlpha"
      :preset-colors="coloresPredefinidos"
      @update:model-value="updateFromPicker"
    />
  </div>
</template>

<script>
import { Sketch } from '@ckpack/vue-color';

const PALETA_PASTELES = [
  '#ffffff',
  '#cccccc',
  '#f8b3ba',
  '#f59598',
  '#f9a586',
  '#efa796',
  '#febd7d',
  '#cdb3d5',
  '#b3b4da',
  '#a6c7ea',
  '#8abade',
  '#689aab',
  '#a9dad1',
  '#90cfb5',
  '#88bbaa',
  '#bbdcad',
  '#bacab2',
  '#f9f08d',
  '#e1e78a',
  '#f1ed8c',
  '#f4f1ae',
  '#ccac90',
  '#fbdede',
];

export default {
  components: {
    'sketch-picker': Sketch,
  },
  props: {
    name: { type: [String, Boolean], default: false },
    defaultColor: { type: String, default: null },
    disableAlpha: { type: Boolean, default: true },
    modelValue: { type: String, default: null },
    posicion: { type: String, default: 'derecha' },
    mostrarInput: { type: Boolean, default: true },
    coloresPredefinidos: { type: Array, default: () => (PALETA_PASTELES) },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      colors: {
        hex: this.defaultColor,
      },
      colorValue: '',
      displayPicker: false,
    };
  },
  computed: {
    clasesBotonColor() {
      let clases = 'color-picker-container';
      if (this.mostrarInput) {
        clases = `${clases} input-group-addon`;
      } else {
        clases = `${clases} form-control`;
      }
      return clases;
    },
  },
  watch: {
    colorValue(val) {
      if (val) {
        this.updateColors(val);
        this.$emit('update:modelValue', val);
        // document.body.style.background = val;
      }
    },
    modelValue(val) {
      this.setColor(val || this.defaultColor);
    },
  },
  mounted() {
    this.setColor(this.modelValue || this.defaultColor);
  },
  methods: {
    setColor(color) {
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      if (!color) {
        return;
      }

      if (color.slice(0, 1) === '#') {
        this.colors = {
          hex: color,
        };
      } else if (color.slice(0, 4) === 'rgba') {
        // Soporte para un valor rgba(...)
        const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
        const hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
        this.colors = {
          hex,
          a: rgba[3],
        };
      }
    },
    showPicker() {
      document.addEventListener('click', this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      document.removeEventListener('click', this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      if (this.displayPicker) {
        this.hidePicker();
      } else {
        this.showPicker();
      }
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      this.colorValue = color.hex;
      // Este código serviría si queremos trabajar con transparencias. De momento no lo usamos
      // if (color.rgba.a === 1) {
      //   this.colorValue = color.hex;
      // } else {
      //   // SI hay transparencia pondría esto
      //   this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g +
      //      ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
      // }
    },
    documentClick(e) {
      const el = this.$refs.colorpicker;
      const { target } = e;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .vc-chrome,
  .vc-sketch {
    position: absolute;
    top: 35px;
    right: 0;
    z-index: 9;
    &.izquierda {
      left: 0;
    }
  }
  .color-picker-container {
    cursor: pointer;
  }

  .current-color {
    display: inline-block;
    width: 16px;
    height: 16px;
    // background-color: #ccc;
  }
  .footer {
    margin-top: 20px;
    text-align: center;
  }
</style>
